import { isSetNewsletterDisplayedCookie, isSetRegionalDisplayedCookie } from '../../helpers/cookie';
import NewsletterLightbox from '../Lightboxes/NewsletterLightbox';
import RegionalLightbox from '../Lightboxes/RegionalLightbox';
import { ModalProps, ModalAutoDisplayerProps } from './interfaces';
import Country from '../../common/models/Country';

const scrollEvent = 'scroll';
const visitEvent = 'visit';

const modalNames = {
  newsletter: 'newsletter',
  regional: 'regional'
};

const newsletterModalConfig = {
  allowedCountries: Country.regionalPopupCountries(),
  event: scrollEvent,
  checkIfCookieSet: isSetNewsletterDisplayedCookie,
  display: ({ setNewsletterVisibility }: ModalAutoDisplayerProps) => {
    setNewsletterVisibility(true);
  },
  maxOncePerPageView: true,
  close: ({ setNewsletterVisibility }: ModalAutoDisplayerProps) => {
    setNewsletterVisibility(false);
  },
  component: NewsletterLightbox,
  checkIfShouldBeDisplayed: ({ newsletterModalVisible }: ModalAutoDisplayerProps) => newsletterModalVisible,

  scrollPercentage: 80.0
};

const regionalModalConfig = {
  allowedCountries: Country.regionalPopupCountries(),
  event: visitEvent,
  checkIfCookieSet: isSetRegionalDisplayedCookie,
  display: ({ setRegionalVisibility }: ModalAutoDisplayerProps) => {
    setRegionalVisibility(true);
  },
  maxOncePerPageView: true,
  close: ({ setRegionalVisibility }: ModalAutoDisplayerProps) => {
    setRegionalVisibility(false);
  },
  component: RegionalLightbox,
  checkIfShouldBeDisplayed: ({ regionalModalVisible }: ModalAutoDisplayerProps) => regionalModalVisible,

  scrollPercentage: undefined
};

const modals: { [name: string]: ModalProps } = {
  [modalNames.newsletter]: newsletterModalConfig,
  [modalNames.regional]: regionalModalConfig
};

export { modals, modalNames, scrollEvent, visitEvent };
